import React, { useState, useCallback, useRef } from 'react';
import {
  GoogleMap,
  useJsApiLoader,
  MarkerClusterer,
} from '@react-google-maps/api';

import { envVariables } from '@/constants/index';

import CustomMarker from './CustomMarker';

import styles from './google-maps.module.scss';

const options = {
  disableDefaultUI: true,
  scaleControl: true,
  mapTypeId: 'roadmap',
  labels: true,
  panControl: true,
  zoomControl: true,
  mapTypeControl: false,
  streetViewControl: false,
  rotateControl: false,
  clickableIcons: false,
  keyboardShortcuts: false,
  scrollWeel: false,
  disableDoubleClickZoom: false,
  fullscreenControl: true,
};

export default function MapContainer({ data }) {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    region: 'AZ',
  });

  const [activeMarker, setActiveMarker] = useState(null);

  const mapRef = useRef(undefined);

  const onLoad = useCallback(
    (map) => {
      mapRef.current = map;
      const bounds = new window.google.maps.LatLngBounds();
      data?.hotspots?.forEach((item) => {
        bounds.extend({
          lat: Number(item.house.lat),
          lng: Number(item.house.lng),
        });
      });
      mapRef.current.fitBounds(bounds);
    },
    [data],
  );

  const onUnmount = useCallback(() => {
    mapRef.current = undefined;
  }, []);

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };
  return isLoaded ? (
    <div className={styles.wrap} itemScope itemType='https://schema.org/Place'>
      <div className={styles.map}>
        <GoogleMap
          mapContainerStyle={{
            height: '100%',
            width: '100%',
          }}
          zoom={10}
          onLoad={onLoad}
          onUnmount={onUnmount}
          options={options}
          onClick={() => setActiveMarker(null)}
        >
          <MarkerClusterer
            averageCenter
            enableRetinaIcons
            gridSize={80}
            maxZoom={15}
          >
            {(clusterer) =>
              data?.hotspots.map((location, index) => (
                <CustomMarker
                  onClick={handleActiveMarker}
                  activeMarker={activeMarker}
                  key={index}
                  position={location}
                  clusterer={clusterer}
                  icon={data?.location_icon}
                />
              ))
            }
          </MarkerClusterer>
        </GoogleMap>
      </div>
    </div>
  ) : (
    <></>
  );
}
